export function ChangeDate(e){
    e.preventDefault();
    localStorage.removeItem('year-date');
    localStorage.removeItem('month-date');
    window.location = "/wybierz-date";
}